export default __webpack_public_path__ + "static/media/人身安全_people-safe.b137c067.svg";